import React, { useState,useEffect,useRef } from 'react';
// import {AnimatePresence, motion} from 'framer-motion/dist/framer-motion'
import Typist from 'react-typist';
import ReactDOM from 'react-dom'
// import Slider from "react-slick";
import axios from "axios";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Slider from '@appigram/react-rangeslider'
import '@appigram/react-rangeslider/lib/index.css';

// import moment from 'moment'
// import moment from 'moment-with-locales-es6';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import {Filler} from 'chart.js'
import { Line } from 'react-chartjs-2';

// import faker from 'faker';
// var faker = require('faker');

import {CopyToClipboard} from 'react-copy-to-clipboard';


import './App.css'
import './Asset/css/animate.css'
import 'bootstrap/dist/css/bootstrap.min.css';

import {animate} from"./Asset/js/animate"
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer } from 'recharts';


// slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import dummy from './images/dummy.jpg'
import opensea from './images/opensea.svg'
import Discord from './images/Discord.svg'
import about1 from './images/a5.PNG'
import openseaIcon from './images/openasea.PNG'
import metaVerse from './images/metaVerse.png'
import kaijuKingzCircle from './images/kaijuKingzCircle.png'
import nft2 from './images/nft2.png'
import nft3 from './images/nft3.png'
import leftElement from './images/leftElement.png'
import rightElement from './images/rightElement.png'
import team1 from './images/team1.jpeg'
import nft1 from './images/nft1.png'
import nft4 from './images/nft4.gif'
import tokenomicsElementLeft from './images/tokenomicsElementLeft.png'
import tokenomicsElementRight from './images/tokenomicsElementRight.png'
import logo from './images/logo.png'
import nft1a from './images/nft1.png'
import nft4a from './images/nft4.png'
import nft5 from './images/nft5.png'
import nft6 from './images/nft6.png'
import nft7 from './images/nft7.png'
import nft8 from './images/nft8.png'
import nft9 from './images/nft9.png'
import nft10 from './images/nft10.png'
import nft3a from './images/nft3a.png'
import nft2a from './images/nft2a.png'
import nft20 from './images/nft20.png'
import nft21 from './images/nft21.png'
import nft22 from './images/nft22.png'
import nft14 from './images/nft14.png'
import nft16 from './images/nft16.png'
import nft11 from './images/nft11.png'
import nft12 from './images/nft12.png'
import nft15 from './images/nft15.png'
import nft17 from './images/nft17.png'
import nft18 from './images/nft18.png'
import nft19 from './images/nft19.png'
import roadElementDown from './images/roadElementDown.png'
import roadElementUp from './images/roadElementUp.png'
import collab from './images/collab.png'
import footerImg from './images/footerImg.png'
import sliderMF from './images/sliderMF.png'



import demoPic from './images/demoPic.jpeg'
// import Slider1 from './component/slickSlider';  
var moment = require('moment-timezone');

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' ,
      labels: {
        color:"#fff"
    }
    
    },
    title: {
      display: true,
      text: 'Price History',
      color:"#fff"

    },
   
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest"
  },
  scales: {
    yAxes: {
      // barPercentage: 1.6,
      grid: {
        // display: false,
        color: 'rgba(144, 150, 188,0.1)',
        // zeroLineColor: "transparent"
      },
      ticks: {
        // suggestedMin: 0,
        // suggestedMax: 125000,
        // padding: 2,
        // backdropPadding: 2,
        // beginAtZero:true,
        backdropColor: "rgba(255,255,255,1)",
        color: '#fff',
        font: {
          // family: "Montserrat", // Add your font here to change the font of your y axis
          size: 12
        },
        major: {
          enable: true
        }
      }
    },
    xAxes: {
      // barPercentage: 1.6,
      grid: {
        // display: false,
        color: 'rgba(255,255,255,0)',

        zeroLineColor: "#fff"
      },
      ticks: {
        // padding: 20,
        color: '#fff',
        font: {
          // family: "Montserrat", // Add your font here to change the font of your x axis
          size: 12
        },

        major: {
          enable: false
        }
      }
    }
  }
  
};



const labels = [ 'March', 'April', 'May', 'June', 'July'];
    
const dataYearDemo = {
 labels,
 datasets: [
   {
     label: 'Dataset 1',
     data: [22,33,99,88,77,1],
     borderColor: '#fff',
     backgroundColor: '#fff',
   },

 ],
};

const dataChart = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];


function App() {
  var [chartData,setChartData]=useState(null)

  var [currentToken,setcurrentToken]=useState({})
  var [temp,setTemp]=useState(false)

  let [mintValue,setmintValue]=useState(1)

  var [day,setDay]=useState("")
  var [hours,setHours]=useState("")
  var [minutes,setMinutes]=useState("")
  var [seconds,setSeconds]=useState("")
  var day1;
  var hours1;
  var minutes1;
  var seconds1;
  useEffect(()=>{
    // time()
    animate()
    chartYear()
    getData()
    // defaults.font.color = '#fff';
  },[temp])
  const notify = (response,types) => 
  types(response, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
});
const notify1 = (response,types) => 
  types(response, {
    position: "top-center",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
});

const handleDiscord=(e,msg)=>{
  // e.preventDefault();
  console.log(msg);
  notify1(`The id "${msg}" is copied to clipboard`,toast.success)
}

  const handleCommingSoon = (e) => {
    e.preventDefault()
    notify("Coming Soon",toast.success)
    console.log("soon");
  } 
 
  function submit(e){
    e.preventDefault()
    console.log("working");
  }
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,

          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          }
        },
       
      ]
  };

  function time(){
    
    var timeElement, eventTime, currentTime, duration, interval, intervalId;
    interval = 1000; // 1 second
  
    // get time element
    // timeElement = document.querySelector("time");
    // calculate difference between two times
    eventTime = moment.tz("2021-11-07T12:00:00", "America/Los_Angeles");
    // based on time set in user's computer time / OS
    currentTime = moment.tz();
    // get duration between two times
    duration = moment.duration(eventTime.diff(currentTime));
  
    // loop to countdown every 1 second
    setInterval(function() {
      // get updated duration
      duration = moment.duration(duration - interval, 'milliseconds');
      
  
      // if duration is >= 0
      if (duration.asSeconds() <= 0) {
        clearInterval(intervalId);
        // hide the countdown element
        // timeElement.classList.add("hidden");
        setDay("00")
        setHours("00")
        setMinutes("00")
        setSeconds("00")
      } else {
        // day1 = duration.days()
        // hours1 = duration.hours()
        // minutes1 =duration.minutes()
        // seconds1=duration.seconds()
        setDay(duration.days())
        setHours(duration.hours())
        setMinutes(duration.minutes())
        setSeconds(duration.seconds())
        // console.log('====================================');
        // console.log(seconds1);
        // console.log('====================================');
        // console.log('====================================');
        // console.log(duration.days()+":"+duration.hours()+":"++":"+duration.seconds())
        // console.log('====================================');
        // otherwise, show the updated countdown
        // timeElement.innerText = duration.years() + " years " + duration.days() + " days " + duration.hours() + " hours " + duration.minutes()  + " minutes " + duration.seconds() + " seconds";
      }
      // setDay(day1)
      // setHours(hours1)
      // setMinutes(minutes1)
      // setSeconds(seconds1)

    }, interval);
    
  }

  const handleCurrentTokenData = (token) =>{
    let currentToken = wholeChartData.find((d)=>d.name == token)
    console.log(token);
    console.log(currentToken);
    setcurrentToken(currentToken)
    temp? setTemp(false) : setTemp(true)
    chartYear()
        
  }

  const wholeChartData = [
    {
      name:"Token #1",
      dataYear:[1,23,54,22,33,99,88,77,1],
      dataWeek:[12,43,14,12,33,88,47,1],
      dataDay:[22,43,14,12,33,88,47,22],
      dataMonth:[22,43,54,12,33,18,47,52],
      data3Month:[42,43,54,52,33,18,47,32],
      dataAllTime:[1,23,54,22,33,99,88,77,1]
    },
    {
      name:"Token #2",
      dataYear:[0,23,94,22,33,19,18,77,1],
      dataWeek:[92,73,74,12,63,28,47,1],
      dataDay:[42,13,44,72,13,58,47,22],
      dataMonth:[12,43,54,12,13,18,47,92],
      data3Month:[12,93,24,52,33,18,47,12],
      dataAllTime:[42,23,54,22,33,99,88,47,1]
    },
    {
      name:"Token #3",
      dataYear:[22,23,94,22,33,19,18,77,1],
      dataWeek:[92,73,74,12,63,28,47,1],
      dataDay:[42,13,44,72,13,58,47,22],
      dataMonth:[12,43,54,12,13,18,47,92],
      data3Month:[12,93,24,52,33,18,47,12],
      dataAllTime:[42,23,54,22,33,99,88,47,1]
    },
    {
      name:"Token #4",
      dataYear:[66,13,94,22,33,19,18,77,1],
      dataWeek:[92,73,74,12,63,28,47,1],
      dataDay:[42,13,44,72,13,58,47,22],
      dataMonth:[12,43,54,12,13,18,47,92],
      data3Month:[12,93,24,52,33,18,47,12],
      dataAllTime:[42,23,54,22,33,99,88,47,1]
    },
    {
      name:"Token #5",
      dataYear:[22,63,94,22,33,19,18,77,1],
      dataWeek:[92,73,74,12,63,28,47,1],
      dataDay:[42,13,44,72,13,58,47,22],
      dataMonth:[12,43,54,12,13,18,47,92],
      data3Month:[12,93,24,52,33,18,47,12],
      dataAllTime:[42,23,54,22,33,99,88,47,1]
    },
    {
      name:"Token #6",
      dataYear:[88,23,94,22,33,19,18,77,1],
      dataWeek:[92,73,74,12,63,28,47,1],
      dataDay:[42,13,44,72,13,58,47,22],
      dataMonth:[12,43,54,12,13,18,47,92],
      data3Month:[12,93,24,52,33,18,47,12],
      dataAllTime:[42,23,54,22,33,99,88,47,1]
    },
    {
      name:"Token #7",
      dataYear:[22,53,94,62,33,19,18,77,1],
      dataWeek:[92,73,74,12,63,28,47,1],
      dataDay:[42,13,44,72,13,58,47,22],
      dataMonth:[12,43,54,12,13,18,47,92],
      data3Month:[12,93,24,52,33,18,47,12],
      dataAllTime:[42,23,54,22,33,99,88,47,1]
    },
    {
      name:"Token #8",
      dataYear:[98,53,94,72,13,19,68,77,1],
      dataWeek:[92,73,74,12,63,28,47,1],
      dataDay:[42,13,44,72,13,58,47,22],
      dataMonth:[12,43,54,12,13,18,47,92],
      data3Month:[12,93,24,52,33,18,47,12],
      dataAllTime:[42,23,54,22,33,99,88,47,1]
    },
    {
      name:"Token #9",
      dataYear:[32,23,24,42,33,79,18,37,1],
      dataWeek:[92,73,74,12,63,28,47,1],
      dataDay:[42,13,44,72,13,58,47,22],
      dataMonth:[12,43,54,12,13,18,47,92],
      data3Month:[12,93,24,52,33,18,47,12],
      dataAllTime:[42,23,54,22,33,99,88,47,1]
    },
    {
      name:"Token #10",
      dataYear:[43,13,74,32,23,49,38,27,1],
      dataWeek:[92,73,74,12,63,28,47,1],
      dataDay:[42,13,44,72,13,58,47,22],
      dataMonth:[12,43,54,12,13,18,47,92],
      data3Month:[12,93,24,52,33,18,47,12],
      dataAllTime:[42,23,54,22,33,99,88,47,1]
    },
  ]

  const chartYear=(e)=> {
    e && e.preventDefault()

    const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    console.log(currentToken?.dataYear);
     const dataYear = {
      labels,
      datasets: [
        {
          label: currentToken?.name ? currentToken?.name : "Token #1",
          data: currentToken?.dataYear ?currentToken?.dataYear : [1,23,54,22,33,99,88,77,1],
          borderColor: '#fff',
          // backgroundColor: '#fff',
          fill: true,
          backgroundColor: "rgba(255,255,255,0.4)",
          
          
        },
     
      ],
    };

    setChartData(dataYear)
    
  }

  const chartWeek = (e) => {
    e.preventDefault()
    const labels = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    
    const dataDay = {
     labels,
     datasets: [
       {
         label: currentToken?.name,
         data: currentToken?.dataWeek,
         borderColor: '#fff',
         fill:true,
         backgroundColor: 'rgba(255,255,255,0.4)',
       },
    
     ],
   };
   setChartData(dataDay)

  }

  const chartDay = (e) => {
    e.preventDefault()
    const labels = ['3:00', '6:00', '9:00', '12:00', '15:00', '18:00', '21:00', '24:00'];
    
    const dataDay = {
     labels,
     datasets: [
       {
         label: currentToken?.name,
         data: currentToken?.dataDay,
         borderColor: '#fff',
         fill:true,
         backgroundColor: 'rgba(255,255,255,0.4)',
       },
    
     ],
   };
   setChartData(dataDay)

  }
  const chartMonth = (e) => {
    e.preventDefault()
    const labels = ['1-5-2022', '5-5-2022', '10-5-2022', '15-5-2022', '20-5-2022', '25-5-2022', '30-5-2022'];
    
    const dataDay = {
     labels,
     datasets: [
       {
         label: 'Dataset 1',
         data: currentToken?.dataMonth,
         borderColor: '#fff',
         fill:true,
         backgroundColor: 'rgba(255,255,255,0.4)',
       },
    
     ],
   };
   setChartData(dataDay)

  }
  
  const chart3Month = (e) => {
    e.preventDefault()
    const labels = ['january', '15', 'fabruary', '15', 'March', '15'];
    
    const dataDay = {
     labels,
     datasets: [
       {
         label: 'Dataset 1',
         data: currentToken?.data3Month,
         borderColor: '#fff',
         fill:true,
         backgroundColor: 'rgba(255,255,255,0.4)',
       },
    
     ],
   };
   setChartData(dataDay)

  }

  const chartAll=(e)=> {
    e.preventDefault()

    const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    
     const dataYear = {
      labels,
      datasets: [
        {
          label: 'Dataset 1',
          data: currentToken?.dataAllTime,
          borderColor: '#fff',
          fill:true,
         backgroundColor: 'rgba(255,255,255,0.4)',
        },
     
      ],
    };

    setChartData(dataYear)
    
  }

  const getData = () => {
    // axios.get('https://sheet.best/api/sheets/2b0007a1-542b-4639-af6c-5c94b2de02ba')
    // .then((res) => {
    //   console.log(res.data);
    //   let weekKey = [];
    //   let weekVal = [];
    //   res.data.forEach((item)=>{
    //     if(item.week){
    //       weekKey.push(item.week)
    //       weekVal.push(parseFloat(item.weekdata) )
    //     }
    //   })
    //   console.log(weekKey);
    //   console.log(weekVal);
    // })

  }


  const handleChangeMint = (value1) => {
    setmintValue(value1)
    console.log(value1);
  }

  useEffect(()=>{
    handleCurrentTokenData("Token #1")
  },[])


  return (
  <>
        {/* section 1 */}
        <nav className="navbar navbar-light navbar-expand-lg  row mx-0   pr-0 ai-center-lg"  style={{alignItems: 'flex-start'}}>
          <div className=" col-md-3 col-lg-2 col-xl-2 col-auto text-center p-0">
            <a className="navbar-brand p-0"  href="#">
                {/* <h3 className="">LOGO</h3> */}
                <img src={logo} alt="Logo" /> 
            </a>
          </div>
          <div className="order-md-2 order-3 toggle-icon-custom">
              <button className="navbar-toggler btn-btn-toggle" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                <i className="fa fa-bars" aria-hidden="true"></i>
              </button>
            </div>
          <div className="collapse navbar-collapse col-lg-7 jc-center collapse-nav" style={{fontWeight: 700, color: 'black'}} id="navbarNavAltMarkup">
              <div className="navbar-nav">
                <a className="nav-item nav-link" href="#concept">Concept </a>
                <a className="nav-item nav-link" href="#mint">MINT</a>
             
                <a className="nav-item nav-link" href="#Team">Team </a>
                {/* <a className="nav-item nav-link" href="#roadmap">Roadmap </a> */}
                <a className="nav-item nav-link" href="#impact">Impact</a>
                <a className="nav-item nav-link" href="#mfPortfolio">MF portfolio</a>
                <div className='connecBtnSm'>
                  <button className='ml-0 mt-2 connectWal'>connect</button>
                </div>
                
              </div>
              
          </div>
          
          <div className=" col-md-auto mt-2 col-5 d-flex ai-center text-center order-md-3 order-1 connect-wallet-small px-0">
            {/* <button className="btn color-white" style={{borderRadius: '10px', backgroundColor: '#b0a895'}}>
              CONNECT WALLET
            </button> */}
            <div className="navSocial">
              {/* <a href="#" target="_blank"><i className="fab fa-instagram"></i></a> */}
              {/* <a href="#" target="_blank" className="opensea"><img  src={Discord} alt="Discord" /></a> */}
              <a href="#"  className="opensea" onClick={(e)=>handleCommingSoon(e)}><img src={opensea} alt="openseaIcon" /></a>
              {/* <a href="#" target="_blank"><i className="fab fa-facebook-f"></i></a> */}
              <a href="https://twitter.com/MetaFundX" target='_blank' ><i className="fab fa-twitter"></i></a>
            </div>
            <div className='connecBtnLarge'>
              <button className='connectWal'>connect</button>
            </div>
          </div>
        </nav>

        {/* launching section */}
        <section className="timeSecMain">
          
          <div className='headerContentMain'>
            <h1 className='text-center'>
              <Typist hideWhenDone={false} avgTypingDelay={200} startDelay={500} > 
              MetaFund 
            </Typist>
            </h1>
            {/* <p className="headerTitle animatable fadeInUp animationDelay600">By Amir, Amit and Ido</p> */}
            <p className="headerTitle  animatable fadeInUp animationDelay900">MetaFund, the first fully operational Metaverse hedge fund. MetaFund directly distributes a percentage of profits to holders, through the ownership of NFTs. Ran by <a href="#Team"> Ido</a> and <a href="#Team"> Amir Green</a>, MetaFund entirely focuses on building in the Metaverse through investment in gaming crypto, infrastructure tokens, and virtual real estate. When it comes to corporate culture, here in MetaFund we believe in using our power for good. We have partnered up with <a href="#impact"> ESGgo</a> to make the world a better place.</p>
            <h1 className='cco'>#CCO</h1>
          </div>
           
        </section>

        <section className='conceptMain' id='concept'>
                <div className="container">
                          <h1>Light Paper Key Concept</h1>
                  <div className="row ai-center jc-center">
                    <div className="col-lg-8 order-lg-1 order-2">
                        <div className='contentDiv '>
                          <p className='animatable fadeInUp'>What is MetaFund? MetFund is an NFT project consisting of 11,111 Funds (NFTs) on the Ethereum blockchain. MetaFund provides entry to the first fully operational hedge fund that puts a complete focus on the future of the metaverse. MetaFund invests primarily in gaming crypto and infrastructure tokens while putting a more minor focus on metaverse real estate. The hedge fund itself will be led by Ido Green and Amir Green. Ido has years of experience running and owning a high-performing hedge fund. While Amir, aka WhaleSon, entered web3 in early 2021 as a Solidity developer, and after discovering NFTs it was only a matter of time until Amir and Ido started building something of their own. Ido and Amir will take the reins of managing operations within the fund itself while heavily relying on community input regarding the investment style, risk tolerance, and more. </p>  
                          <p className='animatable fadeInUp'>We understand the diversification regarding the different investment styles (represented through the 1 of 1s the collection features), which is why MetaFund will allow holders to split into groups building separate portfolios in with like-minded investors. These groups will then be rewarded more funding the better they perform. As a project, we will do our best to ensure holders are making the most educated and knowledgeable decisions, while still taking their own experiences and understanding of the market into count.</p>  
                        </div>  
                    </div>  
                    <div className="col-lg-4 col-10 order-lg-2 order-1 mb-3">
                        <div className="row ml-0 mr-0">
                          <div className="col-6 m-0 p-0 mb-2">
                            <div className='animatable bounceInLeft animationDelay pr1'>
                            <img className="img-fluid " src={nft21} alt="a1.1" />
                            </div>
                          </div>
                          <div className="col-6 m-0 p-0 mb-2">
                            <div className='animatable bounceInLeft animationDelay700 pr1'>
                            <img className="img-fluid "  src={nft22} alt="a1.2" />
                            </div>
                          </div>
                          <div className="col-6 m-0 p-0">
                            <div className='animatable bounceInLeft animationDelay900 pr1'>
                            <img className="img-fluid " src={nft14} alt="a1.3" />
                            </div>
                          </div>
                          <div className="col-6 m-0 p-0">
                            <div className='animatable bounceInLeft animationDelayMed pr1'>
                            <img className="img-fluid " src={nft16} alt="a1.4" />
                            </div>
                          </div>
                        </div>  
                    </div>  
                  </div> 
                  <div className="row">
                    <div className="col">
                      <p className='animatable fadeInUp'>Through investing in gaming crypto and infrastructure tokens, we plan to fractionalize profits to our holders through our token, $FUND. $FUND will be available purely through a staking process and will be given out proportionally to the amount of NFTs owned. $FUND is our way of distributing profits to holders while offering community voting power proportional to the amount of NFTs staked. Finally, $FUND acts as a currency used in both metaverse and IRL events ranging from merch drops to yacht parties. #Network=Networth</p>
                    </div>
                  </div> 
                </div>
            
          </section>

          <section className="countSec" id="mint">
          <div className="container">
          <div className="row jc-center ai-center">
          <div className="col-lg-6 text-center animatable fadeInUp">
              {/* <h1 className='text-center'>image</h1> */}
              {/* <img className='w-100 mintImg' src={nft4} alt="metafund nft" /> */}
              <img className='w-100 mintImg' src={nft7} alt="metafund nft" />
            </div>
            <div className="col-lg-6">
              <div className="countDiv mx-auto animatable fadeInUp">

                <h2>Mint</h2>
                <p>5 Funds per txn</p>
                <div className="nftInfo">
                  <div className="">
                    <p className="pricePerG mb-0">Price per NFT</p>
                    <h4 className="mb-0"> TBA </h4>
                    <p>11,111 remaining</p>
                  </div>
                </div>

                  {/* <div>
                    <input type="text" />
                  </div> */}
                    <div className="crocoPercentDiv ">
                      <div className="whiteDiv">
                        <div className='slider'>
                            <Slider
                              min={1}
                              max={5}
                              step={1}
                              value={mintValue}
                              onChange={(e)=>handleChangeMint(e)}
                            />
                        </div>
                      </div>
                    </div>
                  <div className="totalDiv">
                    <span>Total</span>
                    <h5 className="mb-0">{mintValue} </h5>
                  </div>
                  {/* <button className="submitBtn">Sold Out - Explore on OpenSea</button> */}
                  <button className="submitBtn">Mint</button>

                  <div className="timeDiv ">
                    {/* <div className="time">
                      <h1>{day}</h1>
                      <span>DAYS</span>
                    </div> */}
                    <div className="time">
                      {/* <h1>{hours}</h1> */}
                      <h1>00</h1>
                      <span>HOURS</span>
                      <div className='colon'>:</div>
                    </div>
                    <div className="time">
                      {/* <h1>{minutes}</h1> */}
                      <h1>00</h1>
                      <span>MINUTES</span>
                      <div className='colon'>:</div>
                    </div>
                    <div className="timeLast">
                      {/* <h1>{seconds}</h1> */}
                      <h1>00</h1>
                      <span>SECONDS</span>
                    </div>
                  </div>
              </div>
            </div>
           
          </div>
          </div>
        </section>
          
          <section className='teamSec' id='Team'>
            <img className='element1' src={leftElement} alt="" />
            <img className='element2' src={rightElement} alt="" />
            <div className="container">      
              <h1>The Metafund Founders</h1>
              <div className="row jc-center">
                  <div className="col-lg-3 col-md-6 ">
                    <div className='teamCard animatable fadeInUp animationDelay200'>
                      <div>
                        <div className='imgDiv'>
                          <img src={nft11} alt="" />
                        </div>
                        <h5 className='name'>Amir Green</h5>
                        <p className='designation'>Owner / Co-Founder</p>
                        <p className='desc'>Solidity Developer & Option Trader</p>
                      </div>
                      <div className="teamSocial">
                        <a href="https://twitter.com/0xWhaleson" target='_blank'>
                          <i className='fab fa-twitter'></i>
                        </a>
                        <a>
                          <CopyToClipboard text="whaleson.eth#2273" onCopy={(e) => handleDiscord(e,"whaleson.eth#2273")} >
                          <i className='fab fa-discord'></i>
                          </CopyToClipboard>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 ">
                    <div className='teamCard animatable fadeInUp animationDelay'>
                      <div>
                        <div className='imgDiv'>
                          <img src={ nft12} alt="" />
                        </div>
                        <h5 className='name'>Ido Green</h5>
                        <p className='designation'>Lead Dev / Co-Founder</p>
                        <p className='desc'>Senior Software Engineering Manager At Facebook</p>
                      </div>
                      <div className="teamSocial">
                        <a href="https://twitter.com/greenido" target='_blank'>
                          <i className='fab fa-twitter'></i>
                        </a>
                        <a>
                          <CopyToClipboard text="Ido#6733" onCopy={(e) => handleDiscord(e,"Ido#6733")} >
                          <i className='fab fa-discord'></i>
                          </CopyToClipboard>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 ">
                    <div className='teamCard animatable fadeInUp animationDelay600'>
                      <div>
                        <div className='imgDiv'>
                          <img src={nft15} alt="" />
                        </div>
                        <h5 className='name'>Obelis</h5>
                        <p className='designation'>Artist</p>
                        <p className='desc'>2D Illustrator & Pixel Artist </p>
                      </div>
                      <div className="teamSocial">
                        <a href="https://twitter.com/obelisxx" target='_blank'>
                          <i className='fab fa-twitter'></i>
                        </a>
                       
                        <a>
                          <CopyToClipboard text="Obelisxx#8021" onCopy={(e) => handleDiscord(e,"Obelisxx#8021")} >
                          <i className='fab fa-discord'></i>
                          </CopyToClipboard>
                        </a>
                      </div>
                      
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 ">
                    <div className='teamCard animatable fadeInUp animationDelay200'>
                      <div>
                        <div className='imgDiv'>
                          <img src={nft17} alt="" />
                        </div>
                        <h5 className='name'>Mustu</h5>
                        <p className='designation'>Lead Dev</p>
                        <p className='desc'>Blockchain & MERN Stack Developer </p>
                      </div>
                      <div className="teamSocial">
                        <a href="https://twitter.com/mustafaalvi21" target='_blank'>
                          <i className='fab fa-twitter'></i>
                        </a>
                       
                        <a>
                          <CopyToClipboard text="Paint#8526" onCopy={(e) => handleDiscord(e,"Paint#8526")} >
                          <i className='fab fa-discord'></i>
                          </CopyToClipboard>
                        </a>
                      </div>
                    </div>
                  </div>
               
              </div>
            </div>
          </section>


        <div className=" mt-4">
       

          {/*             9th    S E C T I O N             */}
          {/* <section className="container" id='whitelist'>
            <div className="row roadmap-container my-5  mx-0">
              <div >
                <h3 className="price-Heading mb-4 section9"> WhiteList </h3></div>
              <div className="row mx-0 ai-center">
               
                <div className="col-lg-7">
                  <div className="row mx-0 ai-center animatable bounceInLeft">
                    <div className="col-auto price-content span-blue text-end font-bold">10%</div>
                    <span className="themeyellowColor font-bold"> - </span>
                    <div className="col  whiteListTextRow price-content  lh25 montseratMedium">Lorem ipsum dolor, sit amet consectetur Lorem ipsum dolor, sit amet consectetur .</div>
                  </div>
                  <div className="row mx-0 ai-center animatable bounceInLeft">
                    <div className="col-auto price-content span-blue text-end font-bold">25%</div>
                    <span className=" themeyellowColor font-bold"> - </span>
                    <div className="col  whiteListTextRow price-content  lh25 montseratMedium">Lorem ipsum dolor, sit amet consectetur Lorem ipsum dolor, sit amet consectetur </div>
                  </div>
                  <div className="row mx-0 ai-center animatable bounceInLeft">
                    <div className="col-auto price-content span-blue text-end font-bold">50%</div>
                    <span className=" themeyellowColor font-bold"> - </span>
                    <div className="col  whiteListTextRow price-content  lh25 montseratMedium">Lorem ipsum dolor, sit amet consectetur Lorem ipsum dolor, sit amet consectetur  .</div>
                  </div>
                  <div className="row mx-0 ai-center animatable bounceInLeft">
                    <div className="col-auto price-content span-blue text-end font-bold">75%</div>
                    <span className=" themeyellowColor font-bold"> - </span>
                    <div className="col  whiteListTextRow price-content  lh25 montseratMedium">Lorem ipsum dolor, sit amet consectetur Lorem ipsum dolor, sit amet consectetur   </div>
                  </div>
                  <div className="row mx-0 ai-center animatable bounceInLeft">
                    <div className="col-auto price-content span-blue text-end font-bold">100%</div>
                    <span className=" themeyellowColor font-bold"> - </span>
                    <div className="col  whiteListTextRow price-content  lh25 montseratMedium">Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit, pariatur, tenetur optio blanditiis suscipit doloremque rerum dicta officia, neque repellat ex iure ea numquam architecto vitae soluta. Omnis, deleniti minima.</div>
                  </div>
                </div>
                <div className="col-lg-5 text-center">
                  <img className='w-100' src={demoPic} alt="" />  
                </div>
              </div>
            </div>
          </section> */}

              {/*             4th    S E C T I O N             */}
                    
              {/* <div className="mb-5 container idoContainer" id='ido'>
                <div className='mb-5 animatable fadeInUp' >
                  <h1 className=" mb-4 price-Heading">Ido And Amit</h1>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima blanditiis deleniti, a, deserunt hic aliquid illo veniam est ipsum odit fuga temporibus adipisci harum eveniet neque in, officia at officiis.</p>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima blanditiis deleniti, a, deserunt hic aliquid illo veniam est ipsum odit fuga temporibus adipisci harum eveniet neque in, officia at officiis.</p>
                </div>


                    <div className="slider">
                        <Slider {...settings}>
                        <div className="col">
                          <img src={demoPic} alt="" />
                        </div>
                        <div className="col">
                          <img src={demoPic} alt="" />
                        </div>
                        <div className="col">
                          <img src={demoPic} alt="" />
                         </div>
                        <div className="col">
                          <img src={demoPic} alt="" />
                        </div>
                        <div className="col">
                          <img src={demoPic} alt="" />
                        </div>
                        </Slider>
                    </div>
              </div>  */}
              
          {/* <section className='tokenomicsSec' id="litepaper">
            <img className='tLeftElement' src={tokenomicsElementLeft} alt="tokenomics" />
            <img className='tRightElement' src={tokenomicsElementRight} alt="tokenomics" />
              <div className="container">
                <h1>Litepaper</h1>
                <h6>Features</h6>
                <div className="row jc-center">
                  <div className="col-lg-5 col-md-6">
                    <div className='tContent'>
                     <p>Ethereum Blockchain Flatform</p>
                    </div>
                  </div>
                  <div className="col-lg-5 col-md-6">
                    <div className='tContent'>
                     <p>Ethereum Blockchain Flatform</p>
                    </div>
                  </div>
                  <div className="col-lg-5 col-md-6">
                    <div className='tContent'>
                     <p>Ethereum Blockchain Flatform</p>
                    </div>
                  </div>
                  <div className="col-lg-5 col-md-6">
                    <div className='tContent'>
                     <p>Ethereum Blockchain Flatform</p>
                    </div>
                  </div>
                </div>
              </div>
          </section> */}
        
         
          {/*             11th    S E C T I O N  footer           */}
          {/* <img src={roadElementUp} alt="roadmap" className='roadElementUp w-100' />
          <section className='roadmapSecMain' id="roadmap">
            
                <div className="container">
                  <div className='headingDiv animatable fadeInUp '>
                    <h1>PROGRAMS</h1>
                    <p className='title'>Further benefit the Metafund Community, we plan on utilizing our skillset to launch these programs designed to educate and reward our holders.</p>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className='roadCol animatable fadeInUp animationDelay200'>
                        <div className='imgDiv'>
                          <img src={nft20} alt="metaVerse" />
                        </div>
                        <div>
                          <h3>Angel Investment</h3>
                          <p>Provides holders with the opportunity to have their projects adequately funded and promoted by our team, offering assistance and guidance to ensure holders have all the tools necessory to succeed.  </p>
                        </div>  
                      </div>  
                    </div>  
                    <div className="col-lg-6">
                      <div className='roadCol animatable fadeInUp animationDelay'>
                        <div className='imgDiv'>
                          <img src={nft8} alt="metaVerse" />
                        </div>
                        <div>
                          <h3>Education</h3>
                          <p>Educating holders on the key fundamentals of web3 while providing a quality breakdown of Decentralized Financing. In reference to the different forms of investments within web3 and how to execute them thoughtfully, efficiently, and effectively.</p>
                        </div>  
                      </div>  
                    </div>  
                    <div className="col-lg-6">
                      <div className='roadCol animatable fadeInUp animationDelay600'>
                        <div className='imgDiv'>
                          <img src={nft9} alt="metaVerse" />
                        </div>
                        <div>
                          <h3>Alpha</h3>
                          <p>A competition-based alpha platform, where holders are able to build credibility with a scoring system based on performance of investing in crypto. Credibility will then reward holders through funding, whitelist spots and more. </p>
                        </div>  
                      </div>  
                    </div>  
                    <div className="col-lg-6">
                      <div className='roadCol animatable fadeInUp animationDelay800'>
                        <div className='imgDiv'>
                          <img src={nft10} alt="metaVerse" />
                        </div>
                        <div>
                          <h3>Market</h3>
                          <p>A series of informative channels, designed to analyze the investment world of crypto. Breaking down the market by professionals with real-time examples. Ensuring holders make the most educated and informed decisions while also guiding holders through our thought process regarding building and investing in the Web3 space.</p>
                        </div>  
                      </div>  
                    </div>  
                  </div>
                </div>
          </section>
          <img src={roadElementDown} alt="roadmap" className=' w-100' /> */}


          


          {/* <section className='NetworkMain'  id='network'>
            <div className="container">
                <div className="row networkRow">
                  <div className="col-sm-5  col-6">
                    <img className='w-100' src={nft2} alt="nft" />
                  </div>
                  <div className='circleImg d-none-sm'>
                    <img className='' src={nft1} alt="nft" />
                    
                  </div>
                  <div className="col-sm-5 col-6">
                    <img className='w-100' src={nft2} alt="nft" />
                  </div>
                </div>
              <div className="row">
                  <div className="col-md-8">
                    <h1>Network</h1>
                    <div className='animatable fadeInUp'>
                      <p>Lorem  porro omnis? Quos? Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolor, doloremque, numquam, provident animi doloribus suscipit aliquid inventore voluptate nisi quos alias et amet neque nobis architecto eum ea porro necessitatibus? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ullam architecto magnam, possimus facilis aperiam quod beatae consequuntur veniam exercitationem ipsa, autem rem laborum quisquam fugiat rerum eligendi dolore quaerat quidem.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <img className='w-100' src={nft3} alt="nft" />
                  </div>
              </div>
            </div>
          </section> */}

          <section className='collaboration' id='impact'>
            <div className="container">  
                    <h1>Impact</h1>
              <div className="row ai-center">
                  <div className="col-md-6">
                    <div className='animatable fadeInUp'>
                      <p>Have a true impact. To create a meaningful impact on the world, we decided to partner up with ESGgo, the leading start-up in the environmental science space. To raise funds for this community-based impact, we will be releasing an AI NFT collection consisting of 20,000 Impacts on the Ethereum blockchain.</p>
                      <p>Funds will also be put towards granting opportunities for those who lack funding. The community will vote on teams as passionate as us, and the winners of the vote will receive funding, aid, and all guidance needed to succeed in return for minor equity. Once successful, the funds from the equity will be recycled to help out the next project.</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className='imgDiv'>
                      <img className='w-100' src={collab} alt="nft" />
                    </div>
                  </div>
              </div>
            </div>
          </section>

          <section className='analyticsSec' id="mfPortfolio">
            <div className="container">
              <div className="row">
                <div className="col-md-8">
                  <div className='row1'>
                    <h1>Presale Example</h1>
                    <h2 className="price animatable fadeInUpLong ">$6,004.93</h2>
                    <p className="perc">-$129.82 (-2.12%) <span>Today</span></p>
                    <p className="perc">+$129.82 (+2.12%) <span>After Hours</span></p>
                  </div>
                  <div className="chartRow animatable bounceIn">
                    {/* <ResponsiveContainer width="100%" height="100%">
                      <LineChart width={300} height={100} data={dataChart}>
                        <Line type="monotone" dataKey="pv" stroke="#dd5757" strokeWidth={2} />
                      </LineChart>
                    </ResponsiveContainer> */}
                    <div className='chartDiv'>
                      <Line options={options} data={chartData ?chartData: dataYearDemo} />
                    </div>
                    <div className='timeDiv'>
                      <a href='#' onClick={(e)=> chartDay(e)} className='time'>1D</a>
                      <a href='#' onClick={(e)=>chartWeek(e)} className='time'>1W</a>
                      <a href='#' onClick={(e)=>chartMonth(e)} className='time'>1M</a>
                      <a href='#' onClick={(e)=>chart3Month(e)} className='time'>3M</a>
                      <a href='#' onClick={(e)=>chartYear(e)} className='time'>1Y</a>
                      <a href='#' onClick={(e)=>chartAll(e)} className='time'>ALL</a>
                    </div>
                  </div>
                  <div className="row2 animatable fadeInUpLong ">
                    <p>Buying Power</p>
                    <p>$12,642,500.00</p>
                  </div>
                  {/* <div className="row3">
                    <div className="imgDiv animatable bounceIn ">
                      <img src={nft5} alt="" />
                    </div>
                    <div>
                      <p className="program animatable fadeInUpLong ">New Free Stock Program!</p>
                      <p className="refer animatable fadeInUpLong ">Refer a friend. Pic fractional shares of stock like apple, microsoft, or Aplhabet! Limitation Apply</p>
                      <a href='#' className="invite animatable fadeInUpLong ">Invite friends</a>
                    </div>
                  </div> */}
                </div>
                <div className="col-md-4">
                  <div className="stockMain">
                      <div className="stock">
                        <div className='animatable fadeInUpLong '>MF Analytics</div>
                        {/* <div>
                          <div className="dropdown show">
                            <a className="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="far fa-ellipsis-h"></i>
                            </a>

                            <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                              <a className="dropdown-item" href="#">Action</a>
                              <a className="dropdown-item" href="#">Another action</a>
                              <a className="dropdown-item" href="#">Something else here</a>
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <div className="coinDivMain">
                        <div className="coinDiv animatable fadeInUpLong ">
                          <div className='col1'>
                            <p className="name color-black">Name Of Token</p>
                            <p className="rate color-black"># Of Token  </p>
                          </div>
                          <div className='col2'>
                            <p className="price color-black">Token Price</p>
                            <p className="per"> Percent Change</p>
                          </div>
                        </div>
                        <CoinComp handleCurrentTokenData={handleCurrentTokenData} name="Token #1"  rate="160,550.00" price="161.44"  per={-2.98} />
                        <CoinComp handleCurrentTokenData={handleCurrentTokenData} name="Token #2"  rate="230,070.00" price="161.44"  per={3.98} />
                        <CoinComp handleCurrentTokenData={handleCurrentTokenData} name="Token #3"  rate="835,600.00" price="110"  per={6} />
                        <CoinComp handleCurrentTokenData={handleCurrentTokenData} name="Token #4"  rate="875,400.00" price="121.56"  per={-2.98} />
                        <CoinComp handleCurrentTokenData={handleCurrentTokenData} name="Token #5"  rate="328,960.00" price="191.11"  per={5.21} />
                        <CoinComp handleCurrentTokenData={handleCurrentTokenData} name="Token #6"  rate="450,700.00" price="187.2"  per={-2.98} />
                        <CoinComp handleCurrentTokenData={handleCurrentTokenData} name="Token #7"  rate="200,430.00" price="112.2"  per={12.1} />
                        <CoinComp handleCurrentTokenData={handleCurrentTokenData} name="Token #8"  rate="430.500.00" price="132.33"  per={-1} />
                        <CoinComp handleCurrentTokenData={handleCurrentTokenData} name="Token #9"  rate="290,750.00" price="154.44"  per={2.98} />
                        <CoinComp handleCurrentTokenData={handleCurrentTokenData} name="Token #10" rate="650,800.00" price="192.99"  per={-2.98} />
                        
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>


        <footer>
          <div className="container">
            <div className='logoDiv'>
              <img src={logo} alt="metafund logo" />
            </div>
            <div className="row fRow">
              <div className=" col-lg-5 col-12">
                <h6>Metafund</h6>
                <p>MetaFund, the first fully operational Metaverse hedge fund. MetaFund directly distributes a percentage of profits to holders, through the ownership of NFTs. Ran by <a href="#Team"> Ido</a> and <a href="#Team"> Amir Green</a>, MetaFund entirely focuses on building in the Metaverse through investment in gaming crypto, infrastructure tokens, and virtual real estate. When it comes to corporate culture, here in MetaFund we believe in using our power for good. We have partnered up with <a href="#impact"> ESGgo</a> to make the world a better place.</p>
              </div>
              <div className="col-md-2 col-sm-4 col-6 col2">
                <h6>Quick Links</h6>
                <ul>
                  <li><a href="#concept"> Concept</a></li>
                  <li><a href="#mint"> Mint</a></li>
                  <li><a href="#Team"> Team</a></li>
                  {/* <li><a href="#roadmap"> Roadmap</a></li> */}
                  <li><a href="#impact"> Impact</a></li>
                    <li><a href="#"> MF Portfolio</a></li>
                </ul>
              </div>
           
              <div className="col-md-3 col-lg-2 col-sm-4 col-6 ">
                <h6 className='mt-xs-20'>Contact Us</h6>
                {/* <div className='fSocialRow'>
                  <img src={Discord} alt="" />  
                  <a href="#">metafund</a>
                </div> */}
                <div className='fSocialRow' onClick={(e)=>handleCommingSoon(e)}>
                  <img src={opensea} alt="" />  
                  <a href="#">metafund</a>
                </div>
                <div className='fSocialRow' onClick={(e)=>handleCommingSoon(e)}>
                  <i className='fab fa-twitter'></i>
                  <a href="#">@metafund</a>
                </div>

              </div>
              <div className="col-lg-3">
                <div className="imgDiv">
                  <img className='img-fluid' src={footerImg} alt="nft" />
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/* <section className='rightReserve'>
          <div className="container">
            <div className="row ai-center">
              <div className="col-md-2">
                <div className="imgdiv">
                  <img className='w-100' src={collab} alt="collaborator" />
                </div>
              </div>
              <di className="col-md-7">
                <p className='text'>
                All right reserve ESGgo 2022 .privacy policy . Security, Compliance and Privacy
                </p>
              </di>
              <di className="col-md-3">
                <button className='btn contactBtn'>Contact Us</button>
              </di>
            </div>
          </div>
        </section> */}

      <ToastContainer toastClassName="dark-toast" />
        
      </>
    
  );
}

const CoinComp = ({name,rate,price,per,handleCurrentTokenData}) =>{
  return(
    <div className="coinDiv animatable fadeInUpLong ">
      <div className='col1'>
        <p className="name" onClick={()=> handleCurrentTokenData(name)} >{name}</p>
        <p className="rate">{rate}</p>
      </div>
      <div className='col2'>
        <p className="price">{price}$</p>
        <p className={per<0 ? "per" :"per greenColor"} >{per}%</p>
      </div>
    </div>
  )
}

export {App};
